module.exports = __webpack_public_path__ + "img/PL08780.5a26da24.png";